import React from "react";

//components
import Icon from "../../../icons/Icon"
import { IDragAndDropControls } from "../../../../../interfaces/tables/ISimpleTable";

//interfaces



const DragAndDropControls = (
    {
        className, 
        color, 
        iconName, 
        text
    }   : IDragAndDropControls
) => {   

    return (
        <div className={`button-content ${className}`}>
            <Icon 
                iconName={iconName} 
                sizeInPx="12" 
                color={`${color ?? "#0570B6"}`}
            />

            <span>{text}</span>
        </div>
    )
}

export default DragAndDropControls